let onAuthFailure = null;
let authFailureTriggered = false;

export const setAuthFailureHandler = (handler) => {
    onAuthFailure = handler;
};

export const triggerAuthFailure = () => {
    if (onAuthFailure && !authFailureTriggered) {
        authFailureTriggered = true;
        onAuthFailure();
    }
};

export const resetAuthFailureFlag = () => {
    authFailureTriggered = false;
};
